(function () {
  'use strict';

  var menu     = null;
  var backdrop = null;
  var mainPanel = null;
  var activeSubPanel = null;

  function init() {
    menu      = document.getElementById('site-menu-v2');
    if (!menu) return;

    backdrop  = menu.querySelector('.menu-v2__backdrop');
    mainPanel = menu.querySelector('.menu-v2__panel--main');

    // ── Close triggers ──────────────────────────────────────────
    backdrop.addEventListener('click', closeMenu);
    menu.querySelector('#menu-v2-close-btn').addEventListener('click', closeMenu);

    // ── Search button: close menu, open search ───────────────────
    var searchBtn = menu.querySelector('#menu-v2-search-btn');
    if (searchBtn) {
      searchBtn.addEventListener('click', function () {
        closeMenu();
        // Trigger existing search open (relies on theme's search toggle)
        var existingSearchBtn = document.querySelector('[data-js-search-toggle], .search-toggle, [aria-controls="search"]');
        if (existingSearchBtn) existingSearchBtn.click();
      });
    }

    // ── Submenu open triggers ────────────────────────────────────
    menu.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-v2-open]');
      if (!trigger) return;
      var panelId = trigger.getAttribute('data-v2-open');
      openSubPanel(panelId);
    });

    // ── Submenu back buttons ─────────────────────────────────────
    menu.addEventListener('click', function (e) {
      if (e.target.closest('[data-v2-back]')) closeSubPanel();
    });

    // ── Escape key ───────────────────────────────────────────────
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (activeSubPanel) { closeSubPanel(); return; }
      if (menu.classList.contains('is-open')) closeMenu();
    });

    // ── Intercept hamburger on mobile for variant B ───────────────
    wireMobileMenuButton();
  }

  function wireMobileMenuButton() {
    // Use capture phase so we run before SidebarDrawer's click handler
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.mobile-menu-button');
      if (!btn) return;

      // Only on mobile (portable breakpoint ≤ 1023px matches theme)
      if (window.innerWidth >= 1024) return;

      // Check variant — ABTest may not exist yet if script loads out of order
      var variant = getVariant();
      if (variant !== 'variant_b') return;

      e.stopImmediatePropagation();
      e.preventDefault();
      openMenu();
    }, true);
  }

  function getVariant() {
    // menu_v2 A/B-test stopgezet (inconclusive, 18 mei 2026).
    // Iedereen krijgt het oude menu. Oude variant_b-toewijzingen in
    // localStorage/cookie (_abt_menu_v2) worden bewust genegeerd, zodat
    // devices die tijdens de test bucketet waren niet blijven hangen op v2.
    return 'control';
  }

  function openMenu() {
    if (!menu) return;
    menu.setAttribute('aria-hidden', 'false');
    menu.classList.add('is-open');
    document.body.classList.add('menu-v2-open');
    var firstFocusable = menu.querySelector('button, a');
    if (firstFocusable) setTimeout(function () { firstFocusable.focus(); }, 50);
  }

  function closeMenu() {
    if (!menu) return;
    if (activeSubPanel) {
      activeSubPanel.classList.remove('is-active');
      mainPanel.classList.remove('slide-left');
      activeSubPanel = null;
    }
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('menu-v2-open');
    var hamburger = document.querySelector('.mobile-menu-button');
    if (hamburger) hamburger.focus();
  }

  function openSubPanel(panelId) {
    var panel = document.getElementById(panelId);
    if (!panel) return;
    // Close previous sub if any
    if (activeSubPanel && activeSubPanel !== panel) {
      activeSubPanel.classList.remove('is-active');
    }
    activeSubPanel = panel;
    mainPanel.classList.add('slide-left');
    panel.classList.add('is-active');
    // Scroll sub panel to top
    var body = panel.querySelector('.menu-v2__sub-body');
    if (body) body.scrollTop = 0;
  }

  function closeSubPanel() {
    if (!activeSubPanel) return;
    activeSubPanel.classList.remove('is-active');
    mainPanel.classList.remove('slide-left');
    activeSubPanel = null;
  }

  function trackPdpClicks() {
    if (window.innerWidth >= 1024) return;
    window.dataLayer = window.dataLayer || [];
    var variant = getVariant();
    if (!variant) return;

    var menuEl = variant === 'variant_b'
      ? document.getElementById('site-menu-v2')
      : document.getElementById('site-menu-sidebar');

    if (!menuEl) return;

    menuEl.addEventListener('click', function (e) {
      var link = e.target.closest('a[href]');
      if (!link) return;
      var href = link.getAttribute('href') || '';
      if (!/\/(products|collections)\//.test(href)) return;
      window.dataLayer.push({ event: 'menu_pdp_click', menu_variant: variant });
    });
  }

  // Boot after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); trackPdpClicks(); });
  } else {
    init();
    trackPdpClicks();
  }
})();